import { SvgIcon } from "@mui/material"
import React from "react"

interface IProps {
  sx?: any
}

export function IconParking(props: Readonly<IProps>): React.JSX.Element {
  const { sx } = props

  return (
    <SvgIcon
      {...props}
      xmlns="https://fonts.google.com/"
      strokeWidth={2}
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      stroke="currentColor"
      sx={{
        width: sx?.width ? sx?.width : "24",
        height: sx?.height ? sx?.height : "24",
      }}>
      <path
        d="M240-200v40q0 17-11.5 28.5T200-120h-40q-17 0-28.5-11.5T120-160v-320l84-240q6-18 21.5-29t34.5-11h440q19 
        0 34.5 11t21.5 29l84 240v320q0 17-11.5 28.5T800-120h-40q-17 0-28.5-11.5T720-160v-40H240Zm-8-360h496l-42-120H274l
        -42 120Zm-32 80v200-200Zm100 160q25 0 42.5-17.5T360-380q0-25-17.5-42.5T300-440q-25 0-42.5 17.5T240-380q0 25 17.5
         42.5T300-320Zm360 0q25 0 42.5-17.5T720-380q0-25-17.5-42.5T660-440q-25 0-42.5 17.5T600-380q0 25 17.5 42.5T660-320Zm-460 40h560v-200H200v200Z"
      />
    </SvgIcon>
  )
}
